import axios from 'axios';
import { START_PURCHASE, GET_SESSION_ID_PENDING, GET_SESSION_ID_RESOLVE, GET_SESSION_ID_REJECT, CLEAR_PENDING_PURCHASE,
    CLEAR_ERROR_MESSAGE, CANCEL_SUBSCRIPTION_RESOLVE, CANCEL_SUBSCRIPTION_PENDING, CANCEL_SUBSCRIPTION_REJECT,
    RENEW_SUBSCRIPTION_PENDING, RENEW_SUBSCRIPTION_REJECT, RENEW_SUBSCRIPTION_RESOLVE, SUB_POLLING_START, SUB_POLLING_STOP } from "../constants/actionTypes";
import * as API_URL from "../constants/api"
import { getMazCoreEnvUrl } from '../constants/initializer';

export function startPurchase(itemDetails){
    return function(dispatch) {
        dispatch({ 
            type: START_PURCHASE,
            payload: {
                isPending: true,
                details: itemDetails
            }
        })
    }
}

export function clearPendingPurchase(){
    return function(dispatch) {
        dispatch({ 
            type: CLEAR_PENDING_PURCHASE,
        })
    }
}

export function getPurchaseSessionId(apiParams) {
    return function(dispatch) {
        dispatch({type: GET_SESSION_ID_PENDING})
        axios.post(API_URL.CREATE_PURCHASE_SESSION_ID_API, apiParams)
        .then(data => {
            const sessionId = data.data.session_id;
            const paymentUrl = `${getMazCoreEnvUrl()}/${data.data.url}`;
            const subPollingUrl = `${getMazCoreEnvUrl()}/${data.data.polling_url}`;
            dispatch({type: GET_SESSION_ID_RESOLVE,
                payload: {
                    isLoading: false,
                    sessionId,
                    paymentUrl,
                    subPollingUrl
                }
            })
        })
        .catch(err => {
            const  msg = "Some error occured."
            dispatch({type: GET_SESSION_ID_REJECT,
                payload: {
                    isLoading: false,
                    errorMsg: msg
                }
            })
        })
    }
}

export function cancelSubscription(apiParams) {
    return function(dispatch) {
        dispatch({type: CANCEL_SUBSCRIPTION_PENDING})
        axios.get(API_URL.CANCEL_SUBSCRIPTION_API, { params: apiParams })
        .then(data => {
            dispatch({type: CANCEL_SUBSCRIPTION_RESOLVE})
        })
        .catch(err => {
            const msg= "Some error occured.";
            dispatch({type: CANCEL_SUBSCRIPTION_REJECT, payload: { errorMsg: msg}})
        })
    }
}

export function renewSubscription(apiParams) {
    return function(dispatch) {
        dispatch({type: RENEW_SUBSCRIPTION_PENDING})
        axios.get(API_URL.RENEW_SUBSCRIPTION_API, { params: apiParams })
        .then(data => {
            dispatch({type: RENEW_SUBSCRIPTION_RESOLVE})
        })
        .catch(err => {
            const msg= "Some error occured.";
            dispatch({type: RENEW_SUBSCRIPTION_REJECT, payload: { errorMsg: msg}})
        })
    }
}

export function clearErrorMessage() {
    return function(dispatch) {
        dispatch({ 
            type: CLEAR_ERROR_MESSAGE,
        })
    }
}

export function startSubPolling(url) {
    const api = url;
    return function(dispatch) {
        dispatch({type: SUB_POLLING_START});
        axios.get(api)
        .then(data => {
            if (data.data.success) {
                dispatch({type: SUB_POLLING_STOP, payload: data.data});
            }
        })
        .catch(err => {
            if (err.response.status === 401) {
                dispatch({type: SUB_POLLING_STOP, payload: {isPollingError: true}});
            }
        })
    }
}